import {
    StyleSheet
} from "react-native";
import type {
    SidebarMeasures
} from "../../type";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        position: "relative",
        minWidth: 0
    },
    guide: {
        pointerEvents: "none",
        position: "absolute",
        bottom: 0
    }
});

export const useStyles = ({
    measures,
    borders,
    colors,
    spaces
}: {
    colors: NCoreUIKit.ActivePalette["colors"];
    spaces: NCoreUIKit.ActivePalette["spaces"];
    borders: NCoreUIKit.Borders;
    measures: SidebarMeasures;
}) => {
    return {
        guide: {
            start: measures.square / 2 - borders.separator / 2,
            backgroundColor: colors.content.border.subtle,
            width: borders.separator,
            top: spaces.spacingXxs
        },
        container: {
            paddingTop: spaces.spacingXxs,
            gap: spaces.spacingXxs
        }
    };
};
export default stylesheet;
